export default __webpack_public_path__ + "static/media/ic_alert.718a5089.svg";